import { motion } from 'framer-motion';
import { fadeUp, staggeredFadeIn } from '../../utils/animations';

export function TermsSection() {
    return (
        <section className="bg-[#F8F9FA] py-24 md:py-32" data-testid="terms-section">
            <div className="max-w-5xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight">
                        Simple Terms. No Surprises.
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <motion.div {...fadeUp} className="bg-white border border-gray-100 rounded-sm p-8 shadow-sm text-center" data-testid="term-minimum">
                        <p className="text-4xl font-montserrat font-black text-navy-900 mb-2">3</p>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.2em] uppercase font-inter mb-4">Month Minimum</p>
                        <p className="text-[#6B7280] text-sm leading-relaxed">Enough time to hire, onboard, and see real results.</p>
                    </motion.div>

                    <motion.div
                        {...staggeredFadeIn(0.1)}
                        className="bg-white border border-gray-100 rounded-sm p-8 shadow-sm text-center"
                        data-testid="term-cancellation"
                    >
                        <p className="text-4xl font-montserrat font-black text-navy-900 mb-2">30</p>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.2em] uppercase font-inter mb-4">Day Cancellation Notice</p>
                        <p className="text-[#6B7280] text-sm leading-relaxed">After the initial term, cancel anytime with 30 days notice.</p>
                    </motion.div>

                    <motion.div
                        {...staggeredFadeIn(0.2)}
                        className="bg-white border border-gray-100 rounded-sm p-8 shadow-sm"
                        data-testid="term-buyout"
                    >
                        <p className="text-gold-400 text-xs font-bold tracking-[0.2em] uppercase font-inter mb-4">Buyout Option</p>
                        <p className="text-[#6B7280] text-sm leading-relaxed">Want to keep your VA and end the program? The buyout is 18 months of your current monthly program fee. Because that fee decreases over time, so does your buyout. Retaining more than one VA combines their fees into a single payment.</p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
